import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from '@reduxjs/toolkit';

import {
  convertDataFromServerToRedux,
  convertInitDataFromServerToRedux,
} from 'src/pages/SalesChannelContentEditor/SalesChannelContentPage/EditorPage/tools';

import { msg } from 'src/tools/message';

import {
  EnumCollapseId,
  fixedCollapse,
  generateDefaultFloatingActionsBar,
  generateDefaultIconStyle,
  generateDefaultPageSetting,
  generateDefaultSeoSetting,
} from 'src/pages/SalesChannelContentEditor/SalesChannelContentPage/EditorPage/common';

import {
  getContentContentPage,
  getInitialContentContentPage,
  postContentContentPage,
} from '@/src/request/salesChannel/content';
import {
  EnumReducers,
  getCollapseOpenStatus as _getCollapseOpenStatus,
  getCollapseStatus as _getCollapseStatus,
  getCollapseValidationMsgDisplay as _getCollapseValidationMsgDisplay,
  getContent as _getContent,
  getEntityUuid as _getEntityUuid,
  getGeneralMiniProgramPageInfo as _getGeneralMiniProgramPageInfo,
  getGeneralMiniProgramShare as _getGeneralMiniProgramShare,
  getH1TagUuid as _getH1TagUuid,
  getHasModified as _getHasModified,
  getLoaded as _getLoaded,
  getOpeningCollapse as _getOpeningCollapse,
  getOrder as _getOrder,
  getSalesChannel as _getSalesChannel,
  getSalesChannelName as _getSalesChannelName,
  getState as _getState,
  getSubmitStamp as _getSubmitStamp,
  getVisibleCollapse as _getVisibleCollapse,
} from 'src/pages/SalesChannelContentEditor/slice/selectors';
//import _ from 'lodash';
import { getI18nFromGeneral } from '@/src/tools/tools';
import {
  moduleContentDynamicOnChange as _moduleContentDynamicOnChange,
  moduleContentOnChange as _moduleContentOnChange,
  moduleContentStaticOnChange as _moduleContentStaticOnChange,
  onModuleTypeChange as _onModuleTypeChange,
  handleOnContentListResponsiveLayerEditSubmit,
  handleOnModuleDuplicate,
  visibleModuleCheck,
} from 'src/constrains/DraggableModules/reduxFunctions';
import { isCurrentPrimary } from 'src/constrains/SalesChannelMultiLanguageSelect/index';
import {
  generateDefaultState as _generateDefaultState,
  onCollapseOpen as _onCollapseOpen,
  assData,
  defaultStatus,
  hasError,
} from 'src/pages/SalesChannelContentEditor/slice/reduxCommonFunctions';
//mport { stubTrue } from 'lodash';
//import _ from 'lodash';
export { EnumCollapseId };
//import { history } from 'src/router/history';

export const fetchContentContentPage = createAsyncThunk(
  'fetchSalesChannelContentContentPage',
  async (
    data: any,
    //thunkAPI,
  ) => {
    const { uuid, params = {}, isClone } = data;
    const response = await getContentContentPage(uuid, params);
    const isPrimary = isCurrentPrimary();
    return { response, isPrimary, isClone };
  },
);

export const fetchInitContentContentPage = createAsyncThunk(
  'fetchSalesChannelInitContentContentPage',
  async (
    data: { uuid: string; params: any },
    //thunkAPI,
  ) => {
    const { uuid, params = {} } = data;

    const response = await getInitialContentContentPage(uuid, params);
    const isPrimary = isCurrentPrimary();
    return { response, isPrimary };
  },
);

export const submitContentContentPage = createAsyncThunk(
  'submitSalesChannelContentContentPage',
  async ({ body, params }: any) => {
    const { uuid } = body;

    const response = await postContentContentPage(body, params || {});
    const isPrimary = isCurrentPrimary();
    return { response, isNew: !!!uuid, isPrimary };
  },
);

const _defaultContent = {
  moduleContentOrder: [],
  moduleContentStaticConfig: {},
  moduleContentDynamicConfig: {},
  seoSetting: generateDefaultSeoSetting(),
  iconStyle: generateDefaultIconStyle(),
  pageSetting: generateDefaultPageSetting(),
  floatingBar: generateDefaultFloatingActionsBar(),
};
const _defaultState = _generateDefaultState(fixedCollapse, _defaultContent);
const defaultState = {
  ..._defaultState,
  ...defaultStatus,
};

const salesChannelContentContentPage = createSlice({
  name: 'salesChannelContentContentPage',
  initialState: defaultState,
  //function assignState(){}
  reducers: {
    onModuleTypeChange(state, action) {
      _onModuleTypeChange(state, action.payload);
    },
    moduleContentOnChange(state, action) {
      _moduleContentOnChange(state, action);
    },
    moduleContentStaticOnChange(state, action) {
      _moduleContentStaticOnChange(state, action);
    },
    moduleContentDynamicOnChange(state, action) {
      _moduleContentDynamicOnChange(state, action);
    },
    onDuplicate(state, action) {
      handleOnModuleDuplicate(state, action);
    },

    onCollapseOpen(state, action) {
      const { idArr = [] } = action.payload; //=>[id:string]
      _onCollapseOpen(state, idArr);
    },

    onErrorChange(state, action) {
      const { id, status } = action.payload;
      state.collapseErrorMsgDisplay[id].hasError = status;
    },

    onIconStyleChange(state, action) {
      state.hasModified = true;
      state.iconStyle = { ...state.iconStyle, ...action.payload };
    },

    onSeoSettingChange(state, action) {
      state.hasModified = true;
      state.seoSetting = { ...state.seoSetting, ...action.payload };
    },
    onPageSettingChange(state, action) {
      state.hasModified = true;
      state.pageSetting = { ...state.pageSetting, ...action.payload };
    },
    onFloatingActionsBarChange(state, action) {
      state.hasModified = true;
      state.floatingBar = {
        ...state.floatingBar,
        ...action.payload,
      };
    },
    onMiniProgramShareChange(state, action) {
      state.hasModified = true;
      state.miniProgramShare = {
        ...state.miniProgramShare,
        ...action.payload,
      };
    },
    onContentListResponsiveLayerEditSubmit(state, action) {
      handleOnContentListResponsiveLayerEditSubmit(state, action);
    },
    validation(state) {
      // validateTopCollapses(state); //可以不用
      hasError(state, state.collapseErrorMsgDisplay || {});
      visibleModuleCheck(state);
    },
    resetData(state) {
      assData(state, defaultState);
    },
    onChanged(state) {
      state.hasModified = true;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchContentContentPage.pending, (state) => {
      state.loaded = false;
    });
    builder.addCase(fetchContentContentPage.rejected, (state) => {
      state.loaded = true;
    });
    builder.addCase(fetchContentContentPage.fulfilled, (state, action) => {
      const { response, isPrimary, isClone } = action.payload;
      const _data = convertDataFromServerToRedux(response, isPrimary) || {};

      assData(state, _data);
      if (isClone) state.hasModified = true;
    });
    builder.addCase(fetchInitContentContentPage.fulfilled, (state, action) => {
      const { response } = action.payload;
      const _data = convertInitDataFromServerToRedux(response) || {};
      assData(state, _data);
    });
    builder.addCase(submitContentContentPage.pending, (state) => {
      state.loaded = false;
    });
    builder.addCase(submitContentContentPage.rejected, (state) => {
      state.loaded = true;
    });
    builder.addCase(submitContentContentPage.fulfilled, (state, action) => {
      const { response, isPrimary } = action.payload;
      const _data: any =
        convertDataFromServerToRedux(response, isPrimary) || {};
      msg.success(getI18nFromGeneral('general.status.changessavesuccessfully'));
      console.log(_data);
      assData(state, _data);
    });
  },
});

export const getUuid = () => {
  return createSelector(
    (state: any) => state.salesChannelContent[EnumReducers.contentPage].uuid,
    (state: any) =>
      state.salesChannelContent[EnumReducers.contentPage].contentUuid,
    (state: any) => {
      return (
        state.salesChannelContent[EnumReducers.contentPage]
          .salesChannelContent || {}
      ).salesChannelUuid;
    },

    (uuid, contentUuid, salesChannelUuid) => {
      return { uuid, contentUuid, salesChannelUuid };
    },
  );
};

export const getLoaded = () => {
  return _getLoaded(EnumReducers.contentPage);
};

export const getSubmitStamp = () => {
  return _getSubmitStamp(EnumReducers.contentPage);
};

export const getPageName = () => {
  return createSelector(
    (state: any) =>
      state.salesChannelContent[EnumReducers.contentPage].pageSetting.name,

    (name) => {
      return name;
    },
  );
};

export const getPageSetting = () => {
  return createSelector(
    (state: any) =>
      state.salesChannelContent[EnumReducers.contentPage].pageSetting,
    (state: any) =>
      state.salesChannelContent[EnumReducers.contentPage].timezoneInGmt,

    (pageSetting, timezoneInGmt) => {
      return { ...pageSetting, timezoneInGmt };
    },
  );
};
export const getFloatingActionsBar = () => {
  return createSelector(
    (state: any) =>
      state.salesChannelContent[EnumReducers.contentPage].floatingBar,

    (floatingBar) => {
      return floatingBar;
    },
  );
};

export const getIconStyle = () => {
  return createSelector(
    (state: any) =>
      state.salesChannelContent[EnumReducers.contentPage].iconStyle,

    (iconStyle) => {
      return iconStyle;
    },
  );
};

export const getSeoSetting = () => {
  return createSelector(
    (state: any) =>
      state.salesChannelContent[EnumReducers.contentPage].seoSetting,
    (state: any) => state.salesChannelContent[EnumReducers.contentPage].uuid,
    (state: any) =>
      state.salesChannelContent[EnumReducers.contentPage].contentUuid,

    (seoSetting, uuid, contentUuid) => {
      return seoSetting;
    },
  );
};

export const getContent = (draggableId) => {
  return _getContent(EnumReducers.contentPage, draggableId);
};

export const getState = () => {
  return _getState(EnumReducers.contentPage);
};

export const getOrder = () => {
  return _getOrder(EnumReducers.contentPage);
};

export const getHasModified = () => {
  return _getHasModified(EnumReducers.contentPage);
};

export const getCollapseStatus = (id) => {
  return _getCollapseStatus(EnumReducers.contentPage, id);
};

export const getOpeningCollapse = (order) => {
  return _getOpeningCollapse(EnumReducers.contentPage, order);
};

export const getVisibleCollapse = (order) => {
  return _getVisibleCollapse(EnumReducers.contentPage, order);
};

export const getCollapseValidationMsgDisplay = (id) => {
  return _getCollapseValidationMsgDisplay(EnumReducers.contentPage, id);
};

export const getSalesChannel = () => {
  return _getSalesChannel(EnumReducers.contentPage);
};

export const getSalesChannelName = () => {
  return _getSalesChannelName(EnumReducers.contentPage);
};

export const getCollapseOpenStatus = (id) => {
  return _getCollapseOpenStatus(EnumReducers.contentPage, id);
};

export const getH1TagUuid = () => {
  return _getH1TagUuid(EnumReducers.contentPage);
};

export const getGeneralMiniProgramShare = () => {
  return _getGeneralMiniProgramShare(EnumReducers.contentPage);
};

export const getGeneralMiniProgramPageInfo = () => {
  return _getGeneralMiniProgramPageInfo(EnumReducers.contentPage);
};

export const getEntityUuid = () => {
  return _getEntityUuid(EnumReducers.contentPage);
};

export const {
  moduleContentOnChange,
  moduleContentStaticOnChange,
  moduleContentDynamicOnChange,
  onIconStyleChange,
  onSeoSettingChange,
  onCollapseOpen,
  validation,
  onErrorChange,
  resetData,
  onPageSettingChange,
  onFloatingActionsBarChange,
  onModuleTypeChange,
  onMiniProgramShareChange,
  onContentListResponsiveLayerEditSubmit,
  onChanged,
  onDuplicate,
} = salesChannelContentContentPage.actions;

export default salesChannelContentContentPage.reducer;
